module.exports = __webpack_public_path__ + "static/feature_2-431d38548dd0dd80e500fccd0be0a62a.png";